import { render, staticRenderFns } from "./damagedInvoices.vue?vue&type=template&id=97a06890&"
import script from "./damagedInvoices.vue?vue&type=script&lang=js&"
export * from "./damagedInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports